import {http} from "@/plugins/http";
import {TransactionPreview} from "@/model/transaction-preview";
import {TransactionFilter} from "@/model/transaction-filter";

export const transactionService = new class TransactionService {

  get path (): string {
    return '/transactions'
  }

  async getAllTransactions (transactionFilter: TransactionFilter): Promise<TransactionPreview[]> {
    return ((await http.get(this.path + '/all', {
      params: transactionFilter
    })).data as any[]).map(a => Object.assign(new TransactionPreview(),a))
  }
}
